import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import SelectSearch from 'react-select-search';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    border: '1px solid #e0e0e0',
    borderRadius: '6px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
}));

const ConsulenteSelector = ({
  consulenti,
  onItemSelected,
  record,
  textFieldsDisabled,
  errorMessage,
}) => {
  const classes = useStyles();

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
      className={classes.sectionContainer}
    >
      <Typography
        variant="h6"
        style={{ paddingTop: '6px', paddingBottom: '6px' }}
      >
        Selezionare il consulente associato al nuovo esercizio:
      </Typography>
      <Grid
        container
        direction="column"
        alignItems="center"
        style={{ paddingBottom: '10px' }}
      >
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <SelectSearch
            disabled={textFieldsDisabled}
            options={consulenti.map(({ id, email }) => ({
              value: id,
              name: email,
            }))}
            onChange={onItemSelected}
            value={record.esercizio.consulenteId}
            placeholder="Selezionare un consulente"
          />
          {errorMessage && (
            <Typography
              variant="caption"
              style={{ color: 'red', marginTop: '4px', textAlign: 'center' }}
            >
              {errorMessage}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

ConsulenteSelector.propTypes = {
  consulenti: PropTypes.array.isRequired,
  onItemSelected: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired,
  textFieldsDisabled: PropTypes.bool.isRequired,
};

export default ConsulenteSelector;
